import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { BookmarkIcon, VolumeIcon, PlusCircleIcon, InfoIcon } from 'lucide-react';
interface Word {
  en: string;
  ar: string;
  pronunciation?: string;
  examples?: {
    en: string;
    ar: string;
  }[];
}
interface WordCardProps {
  word: Word;
  isBookmarked: boolean;
  onBookmark: () => void;
}
export function WordCard({
  word,
  isBookmarked,
  onBookmark
}: WordCardProps) {
  const {
    isArabic
  } = useLanguage();
  const [showExamples, setShowExamples] = useState(false);
  const playSound = (text: string) => {
    if ('speechSynthesis' in window) {
      const utterance = new SpeechSynthesisUtterance(text);
      utterance.lang = 'en-US';
      window.speechSynthesis.speak(utterance);
    }
  };
  return <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md overflow-hidden transition-shadow hover:shadow-lg" data-id="element-1665">
      <div className="p-4" data-id="element-1666">
        <div className="flex justify-between items-start mb-3" data-id="element-1667">
          <div data-id="element-1668">
            <h3 className="text-lg font-medium text-gray-900 dark:text-white" data-id="element-1669">
              {word.en}
            </h3>
            <p className="text-blue-600 dark:text-blue-400" dir="rtl" data-id="element-1670">
              {word.ar}
            </p>
            {word.pronunciation && <p className="text-sm text-gray-500 dark:text-gray-400 mt-1" data-id="element-1671">
                /{word.pronunciation}/
              </p>}
          </div>
          <div className="flex items-center gap-1" data-id="element-1672">
            <button onClick={() => playSound(word.en)} className="p-2 text-gray-500 hover:text-blue-600 dark:hover:text-blue-400 transition-colors" aria-label="Play pronunciation" data-id="element-1673">
              <VolumeIcon className="w-5 h-5" data-id="element-1674" />
            </button>
            <button onClick={onBookmark} className={`p-2 ${isBookmarked ? 'text-yellow-500' : 'text-gray-500 hover:text-yellow-500'} transition-colors`} aria-label={isBookmarked ? 'Remove bookmark' : 'Bookmark'} data-id="element-1675">
              <BookmarkIcon className="w-5 h-5" fill={isBookmarked ? 'currentColor' : 'none'} data-id="element-1676" />
            </button>
          </div>
        </div>
        {word.examples && word.examples.length > 0 && <div className="mt-2" data-id="element-1677">
            <button onClick={() => setShowExamples(!showExamples)} className="flex items-center gap-1 text-sm text-gray-600 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 transition-colors" data-id="element-1678">
              {showExamples ? <span data-id="element-1679">{isArabic ? 'إخفاء الأمثلة' : 'Hide examples'}</span> : <>
                  <InfoIcon className="w-4 h-4" data-id="element-1680" />
                  <span data-id="element-1681">{isArabic ? 'عرض الأمثلة' : 'Show examples'}</span>
                </>}
            </button>
            {showExamples && <div className="mt-3 space-y-2 pl-2 border-l-2 border-blue-200 dark:border-blue-800" data-id="element-1682">
                {word.examples.map((example, index) => <div key={index} className="text-sm" data-id="element-1683">
                    <p className="text-gray-700 dark:text-gray-300" data-id="element-1684">
                      {example.en}
                    </p>
                    <p className="text-gray-600 dark:text-gray-400" dir="rtl" data-id="element-1685">
                      {example.ar}
                    </p>
                  </div>)}
              </div>}
          </div>}
      </div>
    </div>;
}